// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpConsentLiTitulo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_consent_li_titulo";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpConsentLiTitulo {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Proveïdors que es vasen en interès legítim per al consentiment",
                "cz": "Společnosti, které se při souhlasu spoléhají na oprávněný zájem",
                "da": "Leverandører, der er afhængige af legitime interesser for samtykke",
                "de": "Unternehmen, die sich auf ein berechtigtes Interesse an der Zustimmung berufen",
                "en": "Vendors that rely on Legitimate interests for consent",
                "eu-ES": "Baimena lortzeko interes legitimoan oinarritzen diren enpresak",
                "fi": "Toimittajat, jotka luottavat oikeutettuihin etuihin suostumuksessaan",
                "fr": "Partenaires qui s\\'appuient sur l\\'intérêt légitime pour obtenir le consentement",
                "ga-ES": "Empresas que dependen dun interese lexítimo para o consentimento",
                "hi": "वे विक्रेता जो सहमति के लिए वैध हितों पर भरोसा करते हैं",
                "hu": "Azok a szállítók, akik a jogos érdekekre támaszkodnak a beleegyezéshez",
                "it": "Società che si basano su interesse legittimo per il consenso",
                "no": "Leverandører som stoler på legitime interesser for samtykke",
                "nl": "Bedrijven die zich baseren op het legitiem belang voor verkregen toestemming",
                "pl": "Firmy, które opierają się na uzasadnionym interesie w celu uzyskania zgody",
                "pt": "Empresas que se baseiam no interesse legítimo para o consentimento",
                "pt-BR": "Empresas que dependem de interesse legítimo para obter consentimento",
                "ro": "Companii care se bazează pe un interes legitim pentru consimțământ",
                "ru": "Компании, основывающиеся на законном использовании пользовательского соглашения",
                "sv": "Leverantörer som förlitar sig på legitima intressen för samtycke",
                "sk": "Spoločnosti, ktoré sa pri získaní súhlasu spoliehajú na oprávnený záujem"
            },
            "defecto": "Empresas que se basan en interés legítimo para el consentimiento"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
